import { FeeBasedOnProfile, FamilySteps, MainAndFamily } from './associationFee';
import { PaymentMethodEnum } from '../../../shared/models/enums/paymentMethod.enum';

/** Vilken nivå avgiften hör till. Samma värden som FeeLevel i API:t. */
export enum FeeLevelEnum {
  CountryAss = 1,
  CountyAss = 2,
  LocalAss = 3,
}

/**
 * Avgiftsfälten för en period. Samma fält som avgiftsformuläret, så en tidigare eller kommande
 * avgift kan visas med samma begrepp som den löpande.
 */
export interface FeePeriodFee {
  paymentMethod?: PaymentMethodEnum;
  sameFeeForAll?: number;
  sameFeeForAllAutogiro?: number;
  mainAndFamily?: MainAndFamily;
  familySteps?: FamilySteps[];
  oneFeeForHousehold?: number;
  oneFeeForHouseholdAutogiro?: number;
  feeBasedOnProfile?: FeeBasedOnProfile[] | null;
  feeFriend?: number;
  feeFriendAutogiro?: number;
}

/**
 * En avgiftsperiod. Perioderna innehåller aldrig den avgift som gäller nu, den ligger kvar på
 * nivån själv och sparas som vanligt genom avgiftsformuläret.
 */
export interface FeePeriod {
  id: number;
  /** yyyyMMdd */
  validFrom: string;
  /** yyyyMMdd, tomt när perioden inte har något slut än */
  validTo?: string;
  /** Sant när perioden ännu inte börjat gälla och därmed går att ändra */
  isPlanned: boolean;
  changedBy?: string;
  created: string;
  fee: FeePeriodFee;
}

export interface FeePeriodList {
  /** yyyyMMdd, när den avgift som gäller nu började gälla */
  currentValidFrom: string;
  periods: FeePeriod[];
}

/** Avgiftsfälten plus det datum de ska börja gälla. */
export type FeePeriodRequest = FeePeriodFee & {
  validFrom: string;
};
